import React from "react";
import {useQuery} from "@apollo/client";
import ListTable from "../../shared/ListTable";
import {getMedicationsQuery} from "../../client/medications/MediactionQueries";
import Loader from "../../shared/Loader";

const ClientMedicationsList = ({ client }) => {
  const { data, loading } = useQuery(getMedicationsQuery, { variables: { clientId: client.id } })

  const header = <tr>
    <th>Medicament</th>
    <th>Dozaj zilnic</th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.name}</td>
      <td>{item.dosage}</td>
    </tr>
  }

  if (loading) return <Loader />;

  return (
    <div className="row justify-content-md-center">
      <div className=" justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.medications} header={header} listItem={listItem}
                     searchFields={['name', 'dosage']} />
        </div>
      </div>
    </div>
  )
};

export default ClientMedicationsList;
